import axios from 'axios'
import { readdirSync, readFileSync } from 'fs'
import matter from 'gray-matter'
import path from 'path'

const API =
  process.env.NODE_ENV === 'development'
    ? process.env.NEXT_PUBLIC_API_LOCAL
    : process.env.NEXT_PUBLIC_API

const getDealer = async (
  queryDealer: string | string[],
  brand: string,
  servicing: boolean,
) => {
  try {
    const response = await axios.post(`${API}/dealers`, {
      dealer: queryDealer,
      servicing,
    })

    if (response?.data[0]?._source?.brands[0].toLowerCase() !== brand) {
      return false
    }

    return response.data[0]._source
  } catch (error) {
    return false
  }
}

const getModel = async (queryModel, locale, formType?) => {
  const MODELS_DIR = path.join(process.cwd(), `./src/content/${locale}/models`)
  let files
  try {
    files = readdirSync(MODELS_DIR)
  } catch (error) {
    return []
  }
  const modelData = files.map((file) => {
    const fullPath = path.join(MODELS_DIR, file)
    const contents = readFileSync(fullPath, 'utf8')
    const { data } = matter(contents)

    return data
  })

  const sortedModelData = modelData.sort((a, b) => (a.order > b.order ? 1 : -1))

  const modelVisability = sortedModelData.filter((model) => {
    if (formType === 'brochure') {
      return model.active && model.visibility.show_brochure
    }

    if (formType === 'test-drive') {
      return model.active && model.visibility.show_testdrive
    }

    if (formType === 'newsletter') {
      return model.active && model.visibility.show_newsletter
    }

    if (formType === 'video-consulation') {
      return model.active && model.visibility.show_video_consulation
    }

    if (formType === 'internal-cans') {
      return model.active && model.visibility.show_internal_cans
    }

    if (formType === 'request-a-callback') {
      return model.active && model.visibility.show_request_a_callback
    }

    if (formType === 'kmi') {
      return model.active && model.visibility.show_kmi
    }

    if (formType === 'get-a-quote') {
      return model.active && model.visibility.show_get_a_quote
    }

    if (formType === 'kinto-bch-get-a-quote') {
      return model.active && model.visibility.show_kinto_request_a_callback
    }

    if (formType === 'power-of-choice') {
      return model.active && model.visibility.show_power_of_choice
    }

    if (formType === 'toyota-thon') {
      return model.active && model.visibility.show_toyota_thon
    }

    if (formType === 'dealer') {
      return model.active && model.visibility.show_contact_us_dealer
    }

    return model.active
  })

  return modelVisability.filter((model) => {
    if (
      queryModel.toLowerCase() === model.rangecode.toLowerCase() &&
      model.active
    ) {
      return model
    }

    if (
      queryModel.toLowerCase() === model.image.id.toLowerCase() &&
      model.active
    ) {
      return model
    }

    if (
      queryModel.toLowerCase() === model.d4t4.id.toLowerCase() &&
      model.active
    ) {
      return model
    }

    if (queryModel.toLowerCase() === model.name.toLowerCase() && model.active) {
      return model
    }

    return false
  })
}

const getPageData = async (context, form?, formModel?, productInfo?) => {
  const { locale, query } = context
  const {
    dealer,
    centre,
    centreId,
    dealerID,
    dealerId,
    model,
    modelID,
    modelId,
    otso,
    olso,
  } = query
  const queryDealer = dealer || centre || centreId || dealerID || dealerId || ''
  const queryModel = model || modelID || modelId || formModel || ''
  const formType = form || ''
  const queryServicing = !!(
    otso === 'true' ||
    olso === 'true' ||
    otso === '' ||
    olso === ''
  )

  const selectedDealer = await getDealer(queryDealer, locale, queryServicing)
  const selectedModel = await getModel(queryModel, locale, formType)
  const settings = await import(
    `../../content/${locale}/settings/global.md`
  ).catch(() => null)

  if (!settings) {
    throw new Error(`No settings found for brand ${locale}`)
  }

  const pageModel = productInfo
    ? { ...productInfo, ...selectedModel[0] }
    : selectedModel[0]

  return {
    brand: locale,
    query,
    formType,
    dealer: selectedDealer || false,
    model: pageModel || false,
    servicing: queryServicing,
    settings: settings?.attributes,
  }
}

export default getPageData
